export enum UserProfilesEnum {
  BACKOFFICE = "BACKOFFICE",
  OUTSOURCED_WORKER = "OUTSOURCED_WORKER",
  OTHER = "OTHER",
}
